// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HL2Ud","hero":"styles_hero__pWfZU","logo":"styles_logo__64r5Q"};